//  notify button show and hide on quick view js start
$(document).ready(function() {
  
   $(document).on('change', '.modal__centered-content .available-variant input[type="radio"]', function() {
        var checkedAvailableVar = $('.modal__centered-content .available-variant input[type="radio"]:checked').length > 0;
        if (checkedAvailableVar) {
            $('.modal__centered-content .klaviyo-bis-trigger').css("display", "none");
        } else {
            $('.modal__centered-content .klaviyo-bis-trigger').css("display", "block");
        }
    });

  
    $(document).on('change', '.modal__centered-content .unavailable-variant input[type="radio"]', function() {
        var checkedUnavailableVar = $('.modal__centered-content .unavailable-variant input[type="radio"]:checked').length > 0;
        if (checkedUnavailableVar) {
            $('.modal__centered-content .klaviyo-bis-trigger').css("display", "block");
        } else {
            $('.modal__centered-content .klaviyo-bis-trigger').css("display", "none");
        }
    });
});

// notify button show and hide on quick view js end
